// Archivo: Caracteristicas.js

document.addEventListener('DOMContentLoaded', () => {
    // Acordeón principal
    const caracterMain = document.querySelector('.caracter-main');
    if (caracterMain) { // Verificar que el elemento existe
        caracterMain.addEventListener('click', () => {
            caracterMain.classList.toggle('active');
            const mainContent = document.querySelector('.caracter-main-content');
            if (mainContent) {
                mainContent.classList.toggle('active');
            }
        });
    }

    // Subacordeones
    const caracterSubaccordions = document.querySelectorAll('.caracter-main-subaccordion');
    caracterSubaccordions.forEach(subaccordion => {
        const header = subaccordion.querySelector('.caracter-main-subaccordion-header');
        if (header) { // Verificar que el header existe
            header.addEventListener('click', () => {
                // Toggle active class for content
                const content = subaccordion.querySelector('.caracter-main-subaccordion-content');
                if (content) {
                    content.classList.toggle('active');
                }
                // Toggle active class for header to rotate arrow
                header.classList.toggle('active');
            });
        }
    });

    // --- Integración del Efecto de Ráfaga ---

    // Función para iniciar el efecto de ráfaga
    function iniciarBrilloCaracter() {
        // Crear el elemento del efecto de ráfaga
        const brillo = document.createElement('div');
        brillo.classList.add('shine-effect-caracter');

        // Añadir el brillo al contenedor de "Características Principales"
        caracterMain.appendChild(brillo);

        // Remover el brillo después de la duración de la animación (5s)
        brillo.addEventListener('animationend', () => {
            brillo.remove();
        });
    }

    // Iniciar el brillo cada 10 segundos
    setInterval(iniciarBrilloCaracter, 10000);

    // Opcional: Iniciar el brillo inmediatamente al cargar la página
    window.addEventListener('load', iniciarBrilloCaracter);
});
